import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { StyledDescriptionBefore, StyledScoreTagValue, StyledExplanationBefore, getQuestionScoreValue } from './base-question-ai-change-preview.strategy';
import { jsx as _jsx } from "react/jsx-runtime";
export var AiDeleteQuestionChangeStrategy = /*#__PURE__*/function () {
  function AiDeleteQuestionChangeStrategy(context) {
    _classCallCheck(this, AiDeleteQuestionChangeStrategy);

    this.context = context;
  }

  _createClass(AiDeleteQuestionChangeStrategy, [{
    key: "renderBadgeIcon",
    value: function renderBadgeIcon() {
      return /*#__PURE__*/_jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/_jsx("path", {
          d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
        })
      });
    }
  }, {
    key: "renderBadgeLabel",
    value: function renderBadgeLabel() {
      var _this$context$label$b;

      return /*#__PURE__*/_jsx("span", {
        children: (_this$context$label$b = this.context.label.badgeDelete) !== null && _this$context$label$b !== void 0 ? _this$context$label$b : 'REMOVE'
      });
    }
  }, {
    key: "renderDescription",
    value: function renderDescription() {
      var _this$context$before, _this$context$before2;

      if (!((_this$context$before = this.context.before) !== null && _this$context$before !== void 0 && _this$context$before.description)) {
        return null;
      }

      return /*#__PURE__*/_jsx(StyledDescriptionBefore, {
        value: (_this$context$before2 = this.context.before) === null || _this$context$before2 === void 0 ? void 0 : _this$context$before2.description
      });
    }
  }, {
    key: "renderScore",
    value: function renderScore() {
      return /*#__PURE__*/_jsx(StyledScoreTagValue, {
        children: getQuestionScoreValue(this.context.before)
      });
    }
  }, {
    key: "renderExplanation",
    value: function renderExplanation() {
      var _this$context$before3, _this$context$before4;

      if (!((_this$context$before3 = this.context.before) !== null && _this$context$before3 !== void 0 && _this$context$before3.explanation)) {
        return null;
      }

      return /*#__PURE__*/_jsx(StyledExplanationBefore, {
        value: (_this$context$before4 = this.context.before) === null || _this$context$before4 === void 0 ? void 0 : _this$context$before4.explanation
      });
    }
  }, {
    key: "renderAnswers",
    value: function renderAnswers() {
      return null;
    }
  }]);

  return AiDeleteQuestionChangeStrategy;
}();